module.exports = __webpack_public_path__ + "img/largeloader_parked.7100212a.svg";